export default __webpack_public_path__ + "static/media/so-small.3cc24a3d.gif";